<template>
  <b-nav-item-dropdown
    id="dropdown-grouped"
    variant="link"
    class="dropdown-language"
    right
  >
    <template #button-content>
      <div style="display: flex;">
        <country-flag
          :country="currentLocale.uniqueSeoCode"
        />
        <span class="ml-50 mt-50 text-body">{{ currentLocale.name }}</span>
      </div>
    </template>
    <b-dropdown-item
      v-for="localeObj in locales"
      :key="localeObj.uniqueSeoCode"
      @click="changeLocaleLanguage(localeObj)"
    >
      <div style="display: flex;">
        <country-flag
          :country="localeObj.uniqueSeoCode"
          size="normal"
        />
        <span class="ml-50 mt-50">{{ localeObj.name }}</span>
      </div>

    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import { BNavItemDropdown, BDropdownItem } from 'bootstrap-vue'
import CountryFlag from 'vue-country-flag'
import LanguageService from '@/api/client/language.service'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    CountryFlag,
  },
  props: {
    locales: {
      type: Array,
      default: () => [],
    },
  },
  // ! Need to move this computed property to comp function once we get to Vue 3
  computed: {
    currentLocale() {
      return this.locales.length > 0 ? this.locales.find(l => l.uniqueSeoCode === this.$i18n.locale) : {}
    },
  },
  methods: {
    changeLocaleLanguage(locale) {
      this.$i18n.locale = locale.uniqueSeoCode
      LanguageService.changeUserPreferences(locale.id)
    },
  },
  setup() {
    /* eslint-disable global-require */

  },
}
</script>

<style>

</style>
